"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("react-hook-schema/core");
const classnames_1 = __importDefault(require("classnames"));
const fieldWrapper_1 = require("./common/fieldWrapper");
const displayWrapper_1 = require("./common/displayWrapper");
const Form_1 = __importDefault(require("react-bootstrap/Form"));
const enquete_1 = require("./enquete");
// eslint-disable-next-line @typescript-eslint/no-var-requires
const parse = require("loose-json");
const Enquete2SchemaComponent = (props) => {
    const { value, registerProps: rawCsvRegisterProps, fieldState, } = (0, core_1.useField)(props, [core_1.requiredValidator]);
    const { registerProps } = (0, core_1.useField)(Object.assign(Object.assign({}, props), { fieldPath: props.schema.setFieldPath }), []);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onChange = (e) => {
        const text = e.target.value;
        const value = (0, enquete_1.parseCsv)(text);
        rawCsvRegisterProps.onChange(text); // csvデータを保存
        registerProps.onChange(value); // jsonデータを保存
    };
    return (react_1.default.createElement(fieldWrapper_1.FieldWrapper, { fieldState: fieldState },
        react_1.default.createElement(Form_1.default.Control, Object.assign({ as: "textarea", className: (0, classnames_1.default)({
                "has-error": fieldState.invalid,
            }), style: { height: "160px" }, value: value || "" }, registerProps, { onChange: onChange }))));
};
Enquete2SchemaComponent.display = (0, displayWrapper_1.DisplayComponent)("Enquete2DisplayComponent");
exports.default = Enquete2SchemaComponent;
